module.exports = __webpack_public_path__ + "img/lookbook_14_center.040c13cc.png";